export default __webpack_public_path__ + "static/media/joytcp-2.4c4d490f.png";